import type { OAISchema } from '~/types/openapi';
import { isMoreThan } from '~/utils/number';

type Props = {
  data: OAISchema['MarketProductDetailsResponseV2'];
};

export function NonDiscountPrice({ data }: Props) {
  return (
    <div className="flex items-center">
      <span className="typo-heading200">
        {data.price ? `${data.price.toLocaleString()}원` : '상담신청 상품'}
      </span>
      {isMoreThan(data.priceBeforeDiscount, data.price) && (
        <span className="ml-4 text-hint line-through typo-paragraph100-regular">
          {data.priceBeforeDiscount?.toLocaleString()}원
        </span>
      )}
    </div>
  );
}
